const rankingItems = [
  { rank: 1, title: '鬼灭之刃 柱训练篇', type: '热血战斗', heat: '🔥 本周最热', change: 'new' },
  { rank: 2, title: '葬送的芙莉莲', type: '奇幻治愈', heat: '⭐ 口碑神作', change: 'up' },
  { rank: 3, title: '迷宫饭 第二季', type: '奇幻美食', heat: '📈 上升最快', change: 'up' },
  { rank: 4, title: '时光代理人 第三季', type: '国创悬疑', heat: '🎯 国漫之光', change: 'same' },
  { rank: 5, title: '咒术回战 第二季', type: '热血战斗', heat: '💥 持续火爆', change: 'down' },
  { rank: 6, title: 'Re:从零开始的异世界生活 S3', type: '异世界', heat: '🔥 人气稳定', change: 'same' },
  { rank: 7, title: '药屋少女的呢喃', type: '古风推理', heat: '✨ 口碑攀升', change: 'up' },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">追番排行</h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-8 md:mb-10">动漫迷们本周最爱的番剧排名</p>
        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          {/* Header */}
          <div className="hidden sm:flex items-center px-4 md:px-6 py-3 border-b border-background-200/70 text-xs font-semibold text-foreground-500 bg-background-50/50">
            <span className="w-12 text-center">排名</span>
            <span className="flex-1">番剧名称</span>
            <span className="w-28 text-center">类型</span>
            <span className="w-32 text-center">热度</span>
          </div>

          {/* Rows */}
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className={`flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-0 px-4 md:px-6 py-3 md:py-3.5 transition-colors hover:bg-primary-50/50 cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              {/* Rank */}
              <div className="w-12 flex items-center justify-center sm:justify-start">
                <span className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-heading font-bold ${
                  item.rank === 1 ? 'bg-primary-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-500 text-background-50' :
                  item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                  'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </span>
              </div>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <span className="text-sm md:text-base font-semibold text-foreground-900 block truncate">{item.title}</span>
                <span className="text-xs text-foreground-400 sm:hidden">{item.type}</span>
              </div>

              {/* Type (desktop) */}
              <div className="hidden sm:flex w-28 justify-center">
                <span className="px-2 py-0.5 bg-accent-100 text-accent-700 rounded-full text-xs font-medium">{item.type}</span>
              </div>

              {/* Heat */}
              <div className="w-32 flex items-center gap-1 sm:justify-center">
                {item.change === 'up' && <i className="ri-arrow-up-line text-secondary-500 text-xs" style={{ width: '1em', height: '1em' }}></i>}
                {item.change === 'down' && <i className="ri-arrow-down-line text-foreground-400 text-xs" style={{ width: '1em', height: '1em' }}></i>}
                {item.change === 'new' && <i className="ri-sparkling-line text-primary-500 text-xs" style={{ width: '1em', height: '1em' }}></i>}
                {item.change === 'same' && <i className="ri-subtract-line text-foreground-300 text-xs" style={{ width: '1em', height: '1em' }}></i>}
                <span className="text-xs md:text-sm text-foreground-600">{item.heat}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}